import gql from "graphql-tag";

export const markGameAsPlayedGQL = gql`
  mutation MarkGameAsPlayed($gameId: String!) {
    markGameAsPlayed(gameId: $gameId) {
      message
    }
  }
`;

export const abandonGameQueueSlotGQL = gql`
  mutation AbandonGameQueueSlot($input: AbandonGameQueueSlotInput!) {
    abandonGameQueueSlot(input: $input) {
      message
    }
  }
`;
